import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { CmpsUser } from '../metric-performance.metadata';

@Component({
    selector: 'cmps-metric-user',
    template: `
        <div
            class="cmps-metric-performance--user-section"
            [class.cmps-metric-performance--user--not-logged-in]="
                !user?.isLoggedIn
            "
            (click)="onUserClick.emit($event)"
        >
            <div class="cmps-metric-performance--user-wrapper">
                <div
                    class="cmps-user-icon"
                    aria-hidden="true"
                >
                    <img
                        *ngIf="photoSafeUrl"
                        [src]="photoSafeUrl"
                        [alt]="user.userName"
                        class="cmps-metric-performance--user-photo"
                    />
                    <cmps-icon
                        *ngIf="!photoSafeUrl && !user.hasPreviousReports"
                        svgIcon="__internal:account-circle"
                        class="cmps-metric-performance--placeholder-icon"
                    >
                    </cmps-icon>
                    <cmps-icon
                        *ngIf="user.hasPreviousReports"
                        [class.cmps-metric-performance--user--has-previous-reports]="
                            user.hasPreviousReports
                        "
                        svgIcon="__internal:account-arrow-left"
                        class="cmps-metric-performance--placeholder-grey-icon"
                    >
                    </cmps-icon>
                </div>

                <div
                    class="cmps-metric-performance--user-name"
                    [cmpsTooltipTrigger]="user.userName"
                >
                    {{ user.userName }}
                </div>
                <cmps-icon
                    *ngIf="showArrow"
                    class="cmps-metric-performance--arrow-down"
                    svgIcon="__internal:chevron-down"
                >
                </cmps-icon>
            </div>
            <cmps-icon
                *ngIf="user?.isLoggedIn"
                class="cmps-metric-performance--user-logged-in cmps-metric-performance--user-list-icons"
                svgIcon="__internal:account-outline"
            >
            </cmps-icon>
            <cmps-icon
                *ngIf="user?.isFavourite && !user?.isLoggedIn"
                class="cmps-metric-performance--user-favourite cmps-metric-performance--user-list-icons"
                svgIcon="__internal:star"
            >
            </cmps-icon>
        </div>
    `,
    host: {
        class: 'cmps-metric-user',
    },
})
export class CmpsMetricUserComponent {
    @Input() user: CmpsUser;
    @Input() showArrow: boolean;
    @Output() onUserClick: EventEmitter<MouseEvent | KeyboardEvent>;

    photoSafeUrl: SafeUrl;

    constructor(private readonly _sanitizer: DomSanitizer) {
        this.onUserClick = new EventEmitter();
        this.photoSafeUrl = null;
    }

    ngOnChanges(): void {
        this.photoSafeUrl = this.getSafePhotoUrl(this.user?.photoUrl);
    }

    getSafePhotoUrl(photoUrl?: string): SafeUrl | null {
        return photoUrl
            ? this._sanitizer.bypassSecurityTrustUrl(photoUrl)
            : null;
    }

    ngOnDestroy(): void {
        this.onUserClick.complete();
    }
}
